import InputBoilerplate from "../InputBoilerplate"

function EmailInput({label, inputName, placeholder, setState}) {
  return (
    <InputBoilerplate
        label={label}
        type={'email'}
        inputName={inputName}
        placeholder={placeholder}
        setState={setState}
    />
  )
}

export default EmailInput